var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758161376712,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 91622,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 841.142857q0-14.848-10.825143-25.746286t-25.746286-10.825143-25.746286 10.825143-10.825143 25.746286 10.825143 25.746286 25.746286 10.825143 25.746286-10.825143 10.825143-25.746286zM914.285714 841.142857q0-14.848-10.825143-25.746286t-25.746286-10.825143-25.746286 10.825143-10.825143 25.746286 10.825143 25.746286 25.746286 10.825143 25.746286-10.825143 10.825143-25.746286zM987.428571 713.142857l0 182.857143q0 22.820571-16.018286 38.838857t-38.838857 16.018286l-841.142857 0q-22.820571 0-38.838857-16.018286t-16.018286-38.838857l0-182.857143q0-22.820571 16.018286-38.838857t38.838857-16.018286l244.004571 0q11.995429 32.036571 40.301714 52.589714t63.122286 20.553143l146.285714 0q34.889143 0 63.122286-20.553143t40.301714-52.589714l244.004571 0q22.820571 0 38.838857 16.018286t16.018286 38.838857zM801.718857 342.820571q-9.728 22.820571-33.718857 22.820571l-146.285714 0 0 256q0 14.848-10.825143 25.746286t-25.746286 10.825143l-146.285714 0q-14.848 0-25.746286-10.825143t-10.825143-25.746286l0-256-146.285714 0q-23.990857 0-33.718857-22.820571-9.728-22.308571 7.972571-39.424l256-256q10.313143-10.825143 25.746286-10.825143t25.746286 10.825143l256 256q17.700571 17.115429 7.972571 39.424z",
    "p-id": 91623
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c739b47b.svg";
export { ForwardRef as ReactComponent };